import type { ReactElement } from 'react';
import React from 'react';
import cx from 'clsx';

import { usePosOpenedByReferrer } from '~/hooks/useReferrer';

import styles from './HorizontalScroll.module.css';

type Props = {
  className?: string;
  children: React.ReactNode[];
  gap?: 8 | 12 | 16;
  itemViewportWidth?: number;
};

const HorizontalScroll = React.forwardRef<HTMLElement, Props>(
  function HorizontalScroll(
    { children, className, gap = 12, itemViewportWidth },
    ref,
  ) {
    const isPosOpened = usePosOpenedByReferrer();
    const countOfChildren = React.Children.count(children);

    return (
      <section
        className={cx([
          styles.wrapper,
          // 포스에서 마켓을 열었을 경우에만 스크롤바가 노출되도록 함.
          isPosOpened ? styles.scrollbar : styles.horizontalScroll,
          className,
        ])}
        ref={ref}
      >
        {React.Children.map(children, (child, index) => {
          return (
            <div
              key={(child as ReactElement<unknown, string>)?.key || index}
              className={cx(styles.item, styles[`gap-${gap}`])}
              style={{
                maxWidth: itemViewportWidth
                  ? Math.floor((itemViewportWidth / 100) * 768)
                  : 'auto',
                width:
                  typeof itemViewportWidth === 'number'
                    ? `calc(${itemViewportWidth}vw + ${
                        // padding까지 chrome은 스크롤 영역으로 확장해서 생각해주는데,
                        // safari는 content 영역까지만 고려해주기때문에, wrapper의 padding을
                        // 기준으로 scroll container를 조정하는게 아니라 scrollItem들의 각각의 width로
                        // 계산될 수 있도록 아래와 같은 padding값들을 추가
                        countOfChildren - 1 === index ? 40 : 20
                      }px)`
                    : 'auto',
              }}
            >
              {child}
            </div>
          );
        })}
      </section>
    );
  },
);

export default HorizontalScroll;
